/**
 * Exclusive open for overlapping transient menus (right-click EntityContextMenu
 * vs Radix DropdownMenu overflow). Opening one surface closes the others.
 */
export const CLOSE_TRANSIENT_MENUS_EVENT = 'maater:close-transient-menus'

export type CloseTransientMenusDetail = {
  /** Caller id - listeners with the same id ignore the event (stay open). */
  source?: string
}

export function closeTransientMenus(source?: string): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent<CloseTransientMenusDetail>(CLOSE_TRANSIENT_MENUS_EVENT, {
      detail: { source },
    }),
  )
}
